import React from 'react';
import { get } from 'lodash-es';
import { defineMessages, FormattedMessage } from 'react-intl';

import { RadioCheckListItem } from 'ui-components/components/radio-check-list/radio-check-list-item';

import style from './adjust-weight.module.less';
import { emptyObject } from 'ui-components/default-props/empty';
import { BulkActions } from '../../../../enums/bulk-actions';
import { BulkConvertedWeightField } from '../../../converted-weight-input/bulk-converted-weight-field';
import ScaleContainer from '../weight/scale-container';

const messages = defineMessages({
  setWeight: {
    description: 'bulkActions.adjustWeight.setWeight',
    defaultMessage: 'Set Weight',
    id: 'xCdq1t',
  },
  addWeight: {
    description: 'bulkActions.adjustWeight.addWeight',
    defaultMessage: 'Add to Current Weight',
    id: 'MQn8ZB',
  },
});

const weightChangeTypes = [
  {
    id: 'set-weight',
    translation: messages.setWeight,
  },
  {
    id: 'add-weight',
    translation: messages.addWeight,
  },
];

export default {
  id: BulkActions.adjustWeight.name,
  render: (onChange, model, jobData) => {
    const { bulkUpdateJobId } = jobData;
    const shippingConfiguration = get(model, 'shippingConfiguration', emptyObject);
    const firstPackage = get(shippingConfiguration, 'packages.0', emptyObject);
    const weight = get(firstPackage, 'weight', emptyObject);
    const weightType = get(model, 'weightType', 'set-weight');
    const updatePackageWeight = (newWeight, unit) => {
      onChange({
        ...model,
        shippingConfiguration: {
          ...shippingConfiguration,
          packages: [
            {
              ...firstPackage,
              weight: {
                weight: newWeight,
                weightUnit: unit,
              },
            },
          ],
        },
      });
    };
    return (
      <div className={style['adjust-weight']}>
        <div className={style['weight-options']}>
          {weightChangeTypes.map(({ id, translation }) => (
            <RadioCheckListItem key={id} isChecked={weightType === id} onChecked={() => onChange({ ...model, weightType: id })}>
              <FormattedMessage {...translation} />
            </RadioCheckListItem>
          ))}
        </div>
        <div className={style['weight-input']}>
          <BulkConvertedWeightField
            onChange={updatePackageWeight}
            renderScale={() => <ScaleContainer jobId={bulkUpdateJobId} />}
            weight={weight}
          />
        </div>
      </div>
    );
  },
};
